exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-group-dropdown .dropdown-menu{width:331px}.save-group-dropdown .scroll-container{overflow-y:auto;max-height:322px}.save-group-dropdown .group-dropdown-item{cursor:pointer;padding-left:12px;padding-top:8px;padding-bottom:8px;margin:0;border-radius:4px;font-size:14px}.save-group-dropdown .group-dropdown-item:hover{background:var(--border-color)}.save-group-dropdown .group-dropdown-item:last-child{margin-bottom:0}.save-group-dropdown .save-group-dropdown-button{padding:7px 8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:114px;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-390a4b78","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/group/saveGroupDropdown.vue
// module id = m7Ui
// module chunks = 1 6 21 31 33 36 37 38 40 41 43 45 46 47 48 49 52 54 59